<aside [hidden]="!showSidebar" class="sidebar" style="z-index: 7">
    <!-- <div class="adminprofile">
        <a class="navbar-brand logo" style="width: 100%; display: inline-flex; justify-content: center;">
            <img class="lg-logo" [src]="profileData?.profilePic || 'assets/img/profile-img.jpg'" alt="image" style=" border-radius: 50px; cursor: pointer;" (click)="adminProfile()">
        </a>
        <div id="admin" class="profile-data-section" style="text-align: center; color: #221d54;">
            <label style="cursor: pointer;" (click)="adminProfile()">{{profileData?.name || 'Admin' }}</label>
            <p style="cursor: pointer;" (click)="adminProfile()">{{profileData?.email || 'admin@gmail.com' }}</p>
        </div>
    </div> -->
    <div class="sidebar-scroller">
        <div id="accordion" class="sidebar-menu">
            @if(permission?.dashboard == true){
            <div class="menu-box toggle-menu"
                [ngClass]="currentUrl === '/dashboard' ? 'active' : ''" style="border-top: 1px solid #1975a7;">
                <div class="card-header clearfix" [routerLink]="['/dashboard']" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-dashboard" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Dashboard</span></a>
                </div>
            </div>
            }
            @if(permission?.subadminManagement == true){
            <div class="menu-box toggle-menu" [ngClass]="{active : currentUrl === '/subadmin-mgt' || currentUrl === '/add-subadmin' ||
             currentUrl === '/view-subadmin' || currentUrl === '/edit-subadmin'}">
                <div class="card-header clearfix" id="headingThree" routerLink="/subadmin-mgt" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-user" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Subadmin Management</span></a>
                </div>
            </div>
            }
            @if(permission?.patientManagement == true){
            <div class="menu-box toggle-menu" [ngClass]="{active : currentUrl === '/patient-mgt' || currentUrl === '/add-patient' ||
            currentUrl === '/view-patient' || currentUrl.indexOf('/edit-patient') > -1}">
                <div class="card-header clearfix" id="headingThree" data-toggle="collapse" data-target="#collapseThree"
                    aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu" routerLink="/patient-mgt">
                        <span class="side_menu_icon"><i class="fa fa-hospital-o" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Patient Management</span></a>
                </div>
            </div>
            }
            @if(permission?.therapistManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/therapist' || currentUrl === '/add-therapist' ||
             currentUrl === '/edit-therapist' ||  currentUrl === '/view-therapist' || currentUrl === '/staff-availability'}">
                <div routerLink="/therapist" class="card-header clearfix" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-user-md" aria-hidden="true"></i></span>
                        <span class="side_page_name head_color">
                            Therapist Management
                        </span>
                    </a>
                </div>
            </div>
            }
            @if(permission?.programTypeManagement == true){
            <div class="menu-box toggle-menu" [ngClass]="{active : currentUrl === '/program-type-mgt' || currentUrl === '/add-program-type' ||
            currentUrl === '/edit-program-type'}">
                <div routerLink="/program-type-mgt" class="card-header clearfix" id="headingThree"
                    data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                    aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon">
                            <i class="fa fa-calendar" aria-hidden="true"></i></span>
                        <span class="side_page_name head_color">Program Type Management</span></a>
                </div>
            </div>
            }
            @if(permission?.programManagement == true){
            <div class="menu-box toggle-menu" [ngClass]="{active : currentUrl === '/program-mgt' || currentUrl === '/add-program' ||
            currentUrl === '/edit-program'}">
                <div routerLink="/program-mgt" class="card-header clearfix" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon">
                            <i class="fa fa-calendar" aria-hidden="true"></i></span>
                        <span class="side_page_name head_color">Program Management</span></a>
                </div>
            </div>
            }
            @if(permission?.transactionManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="currentUrl === '/transaction-mgt' ? 'active': ''">
                <div class="card-header clearfix" routerLink="/transaction-mgt" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon">
                            <i class="fa fa-exchange" aria-hidden="true"></i></span>
                        <span class="side_page_name head_color">Transaction Management</span></a>
                </div>
            </div>
            }
            @if(permission?.assesmentManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/assessment' || currentUrl === '/edit-assessment' || currentUrl === '/edit-question'}">
                <div class="card-header clearfix" routerLink="/assessment" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon">
                            <i class="fa fa-quora" aria-hidden="true"></i></span>
                        <span class="side_page_name head_color">Assessments and Forms</span></a>
                </div>
            </div>
            }
            @if(permission?.contentManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/static-content' || currentUrl === '/edit-static'}">
                <div class="card-header clearfix" [routerLink]="['/static-content']" id="headingThree"
                    data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                    aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-file-text" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Static Content Management</span></a>
                </div>
            </div>
            }
            @if(permission?.faqManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/faq-mgt' || currentUrl === '/edit-faq' || currentUrl === '/add-faq' || currentUrl === '/view-faq'}">
                <div class="card-header clearfix" [routerLink]="['/faq-mgt']" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-file-text" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Faq Management</span></a>
                </div>
            </div>
            }
            @if(permission?.journalManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/journal-mgt' || currentUrl === '/edit-journal' || currentUrl === '/view-journal'}">
                <div class="card-header clearfix" [routerLink]="['/journal-mgt']" id="headingThree"
                    data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                    aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-file-text" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Journal Management</span></a>
                </div>
            </div>
            }
            @if(permission?.notificationManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="currentUrl === '/notification' ? 'active': ''">
                <div class="card-header clearfix" [routerLink]="['/notification']" id="headingThree"
                    data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                    aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-bell" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Notification Management</span></a>
                </div>
            </div>
            }
            @if(permission?.libraryManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/library-mgt' || currentUrl === '/add-library' || currentUrl === '/view-library'}">
                <div class="card-header clearfix" [routerLink]="['/library-mgt']" id="headingThree"
                    data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                    aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-file" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Library/ Handout management</span></a>
                </div>
            </div>
            }
            @if(permission?.reviewManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/review-mgt' || currentUrl === '/view-review'}">
                <div class="card-header clearfix" [routerLink]="['/review-mgt']" id="headingThree"
                    data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                    aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-star" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Review and Rating Management</span></a>
                </div>
            </div>
            }
            @if(permission?.queryManagement == true){
            <div class="menu-box toggle-menu"
                [ngClass]="{active : currentUrl === '/query-mgt' || currentUrl === '/view-query'}">
                <div class="card-header clearfix" [routerLink]="['/query-mgt']" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-question-circle"
                                aria-hidden="true"></i></span><span class="side_page_name head_color">Query
                            Management</span></a>
                </div>
            </div>
            }
            @if(permission?.chatManagement == true){
            <div class="menu-box toggle-menu" [ngClass]="{active : currentUrl === '/chat'}">
                <div class="card-header clearfix" [routerLink]="['/chat']" id="headingThree" data-toggle="collapse"
                    data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <a class="side_menu">
                        <span class="side_menu_icon"><i class="fa fa-comments" aria-hidden="true"></i></span><span
                            class="side_page_name head_color">Chat Management</span></a>
                </div>
            </div>
            }

            <div class="menu-box">
                <div class="card-header clearfix" id="headingOne">
                    <a class="side_menu" (click)="logOutModal()">
                        <span class="side_menu_icon"><img src="assets/img/logout-icon.png" alt="Icon"></span><span
                            class="side_page_name head_color">Log Out</span>
                    </a>
                </div>
            </div>

        </div>
    </div>

</aside>




<!-- logout modal -->
<div class="modal fade global-modal reset-modal" id="logoutModal">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Logout?</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to logout?</p>
                                <div class="modal-btn-box">
                                    <button type="button" class="btn btn-theme" (click)="logout()">YES</button>
                                    <button type="button" style="min-width: 100px;" class="btn btn-danger ms-2"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>